<template>
  <div class="widget-actions-compact driver-actions">
    <button type="button" class="back-button-premium" @click="emit('back')">← Atrás</button>

    <el-button
      type="primary"
      size="large"
      class="continue-button premium-button"
      :disabled="!isComplete"
      :loading="isLoading"
      @click="emit('submit')"
    >
      Ver cotizaciones
    </el-button>
  </div>
</template>

<script setup lang="ts">
defineProps<{ isComplete: boolean; isLoading: boolean }>();

const emit = defineEmits<{
  back: [];
  submit: [];
}>();
</script>

<style scoped src="./actions.css"></style>
